import React from "react";

function IconModalClose({onClick}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 23 23"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        d="M.293 20.308a1 1 0 101.414 1.414l9.3-9.3 9.301 9.3a1 1 0 101.415-1.414l-9.3-9.3 9.3-9.3A1 1 0 1020.308.292l-9.3 9.3-9.3-9.3A1 1 0 00.292 1.707l9.3 9.3-9.3 9.3z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconModalClose;
